import { axiosInstance } from 'boot/axios';
import { mapArrayForGetRequest, dataModificationRedirect } from 'src/utils/helpers.js';
import Agreement from 'src/models/agreement.js';
import AgreementDetails from 'src/models/agreementDetails.js';
import Notify from 'src/constants/notify';

import i18n from 'src/i18n/index.js';

export function getOfferYear({ commit }) {
  return axiosInstance.get('Agreement/GetYearForOfferedAgreement').then((response) => {
    if (response.status === 200) {
      commit('setOfferYear', response.data);
    }
  });
}

export function clearOfferYear({ commit }) {
  commit('clearOfferYear');
}

export function setNotShowAnymore({ commit }) {
  commit('setNotShowAnymore');
}
export function getAgreements({ commit }) {
  commit('setIsLoadingAgreements', true);

  return axiosInstance
    .get('Agreement/GetMostRecentAgreements')
    .then((response) => {
      if (response.status === 200) {
        commit(
          'setAgreements',
          response.data.map((agreement) => new Agreement(agreement)),
        );
      }
    })
    .finally(() => commit('setIsLoadingAgreements', false));
}

export function getAgreementsByRoleAndFilter({ commit }, payload) {
  commit('setIsLoadingAgreements', true);
  const agreementFilters = mapArrayForGetRequest('activeFilters', payload.agreementFilters);
  return axiosInstance
    .get(`Agreement/GetAgreementsByRoleAndFilter?role=${payload.role}&${agreementFilters}`)
    .then((response) => {
      if (response.status === 200) {
        commit(
          'setAgreements',
          response.data.map((agreement) => new Agreement(agreement)),
        );
      }
    })
    .finally(() => commit('setIsLoadingAgreements', false));
}

export function clearAgreements({ commit }) {
  commit('clearAgreements');
}

export function clearAgreementDetails({ commit }) {
  commit('clearAgreementDetails');
}

export function getPaymentDetails({ commit }, payload) {
  return axiosInstance
    .get(`Agreement/GetPaymentDetails?agreementId=${payload.agreementId}&contractCode=${payload.contractCode}`)
    .then((response) => {
      if (response.status === 200) {
        commit('setPaymentDetails', {
          id: payload.agreementId,
          details: response.data,
        });
      }
    });
}

export function getHasKnownIban({ commit }, payload) {
  const query = payload?.agreementId ? `?agreementId=${payload?.agreementId}` : '';
  return axiosInstance.get(`Agreement/HasKnownIban${query}`).then((response) => {
    if (response.status === 200) {
      commit('setHasKnownIban', response.data.hasKnownIban);
      commit('setHasIbanPayedByInsured', response.data.ibanPayedByInsured);
    }
  });
}

export function updatePaymentDetails(_, payload) {
  return axiosInstance
    .post('Agreement/UpdatePaymentDetails', payload)
    .then(() => {
      Notify.create({
        progress: true,
        icon: 'done',
        color: 'positive',
        message: i18n.global.t('edit-payment-details.valid'),
      });
      dataModificationRedirect('payment-details', this.$router);
    })
    .catch((error) => {
      Notify.create(
        {
          color: 'negative',
          message: i18n.global.t('edit-payment-details.error-saving'),
        },
        error.response,
      );
    });
}

export function updateIban(_, payload) {
  return axiosInstance.post('Agreement/UpdateIban', payload).catch((error) => {
    Notify.create(
      {
        color: 'negative',
        message: i18n.global.t('edit-payment-details.error-saving'),
      },
      error.response,
    );
  });
}

export function getAgreementDetailsForYear({ commit }, payload) {
  commit('setIsLoadingAgreements', true);

  return axiosInstance
    .get(`Agreement/getAgreementDetailsForYear?year=${payload}`)
    .then((response) => {
      if (response.status === 200) {
        commit(
          'setAgreementDetails',
          response.data.map((agreementDetail) => new AgreementDetails(agreementDetail)),
        );
        commit('addPoliciesToAgreementDetails', response.data);
      }
    })
    .finally(() => {
      commit('setIsLoadingAgreements', false);
    });
}

export function getAgreementDetailsForOfferYear({ commit }, payload) {
  commit('setIsLoadingAgreements', true);

  return axiosInstance
    .get(`Agreement/getAgreementDetailsForYear?year=${payload}`)
    .then((response) => {
      if (response.status === 200) {
        commit(
          'setAgreementDetailsForOfferYear',
          response.data.map((agreementDetail) => new AgreementDetails(agreementDetail)),
        );
        commit('addPoliciesToAgreementDetailsForOfferYear', response.data);
      }
    })
    .finally(() => {
      commit('setIsLoadingAgreements', false);
    });
}

export function updateMedicalSelectionForAgreementParticipant({ commit }, payload) {
  commit('updateMedicalSelectionForAgreementParticipant', payload);
}

export function updateEditPolicyDenialReason({ commit, rootGetters }, payload) {
  commit('setHasLoadedEditPossible', false);

  return axiosInstance
    .post('Agreement/AgreementMutable', payload)
    .then((response) => {
      if (response.status === 200) {
        commit('updateEditPolicyDenialReasons', {
          currentUser: rootGetters['user/user'],
          contractMutabilities: response.data,
          policyYear: payload.policyYear,
        });
      }
    })
    .finally(() => commit('setHasLoadedEditPossible', true));
}

export function clearHasLoadedEditPossible({ commit }) {
  commit('setHasLoadedEditPossible', false);
}

export function getHasBasicInsurance({ commit, state }) {
  const agreementDetails = state.agreementDetails;
  const hasBasicInsurance = agreementDetails.some((agreemenDetail) =>
    agreemenDetail.agreementParticipants.some((agreementParticipant) =>
      agreementParticipant.productTypes.some((productType) => productType === 'Basisverzekering'),
    ),
  );
  commit('setHasBasicInsurance', hasBasicInsurance);
}
